/**
 * Permissions consumed by the bulk account-management domain.
 *
 * Operator gating reuses the *existing* singular-admin permissions — no new
 * "initiate" permission is introduced (requirements §12). The two
 * `bulk_upsert_approve` permissions are new (requirements §8.7) and gate the
 * AMS approval surfaces; they are unassigned to any role at launch.
 */
export enum Permission {
  /** Operator gate for bulk *user* operations (existing singular permission). */
  ManageUsersModify = 'manage_users.legacy_permission',
  /** Operator gate for bulk *role* operations (existing singular permission). */
  RoleManagementModify = 'role_management.modify',
  /** Approver gate for bulk *user* operations (new — §8.7). */
  ManageUsersBulkUpsertApprove = 'manage_users.bulk_upsert_approve',
  /** Approver gate for bulk *role* operations (new — §8.7). */
  RoleManagementBulkUpsertApprove = 'role_management.bulk_upsert_approve',
}
